import React, {useContext, useEffect, useState} from 'react';
import * as Builder from "../../../builder";
import {ButtonBar} from "../../../builder";
import {
    RepeatedConstraint,
    RequiredConstraint
} from "../../../builder/form/validation/constraints";
import {Button} from "antd";
import {Translate} from "../../../components/util/translation.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {observer} from "mobx-react";
import {StoreContext} from "../../../store.context";
import {useNavigate} from "react-router-dom";
import {MyAccountPasswordEditRequest} from "../../../types/modules/user/request";
import {TextType} from "../../../builder/form/type/TextType";
import {RepeatedType} from "../../../builder/form/type/RepeatedType";
import {PasswordType} from "../../../builder/form/type/PasswordType";
import {PasswordValidationConstraints} from "../../../builder/form/validation/form_type_constraints";

export const MyAccountPasswordEditForm: React.FC<{ onCancel?: () => void }> = observer(({onCancel}) => {
    const navigate = useNavigate();
    const formReference = React.createRef() as any;

    const [fetching, setFetching] = useState<boolean>(true)

    const {
        appStore: {
            moduleStore: {
                userStore: {
                    myAccount, myAccountPasswordEdit
                }
            }
        }
    } = useContext(StoreContext);

    const [formErrors, setFormErrors] = useState<any>([])

    useEffect(() => {
        myAccount().then((data) => {
            formReference.current?.setData(data);
            setFetching(false);
        });
    }, [myAccount])

    const onSubmit = (values: MyAccountPasswordEditRequest) => {
        setFetching(true);
        myAccountPasswordEdit(values)
                .then(() => {
                    navigate(`/my_account`);
                })
                .catch(error => {
                    setFormErrors(error.response.data.errors);
                })
                .finally(() => {
                    setFetching(false);
                })
    }

    return (
            <>
                <Builder.Form
                        translationDomain={TranslationDomainEnum.USER_ADMINISTRATION}
                        formErrors={formErrors}
                        ref={formReference}
                        items={[
                            {
                                title: <Translate message={`global.title.change_password`}/>,
                                position: 'left',
                                inputs: [
                                    {
                                        name: 'credentials.currentPassword',
                                        label: 'user.field.currentPassword',
                                        type: PasswordType,
                                        constraints: [
                                            RequiredConstraint(),
                                        ]
                                    },
                                    {
                                        name: 'credentials.otp',
                                        label: 'user.field.otp',
                                        type: TextType,
                                    },
                                    {
                                        type: RepeatedType,
                                        firstFieldName: 'plainPassword',
                                        secondFieldName: 'plainPasswordRepeat',
                                        firstLabel: 'user.field.plainPassword',
                                        secondLabel: 'user.field.plainPasswordRepeat',
                                        translationDomain: TranslationDomainEnum.USER_ADMINISTRATION,
                                        firstFieldConstraints: PasswordValidationConstraints(),
                                        secondFieldConstraints: [
                                            RequiredConstraint(),
                                            RepeatedConstraint('plainPassword'),
                                        ],
                                    },
                                ]
                            },

                        ]}
                        onFinish={(values: any) => {
                            onSubmit(values)
                        }}
                />

                <ButtonBar>
                    <Button type="primary" loading={fetching} htmlType={`submit`} onClick={() => {
                        formReference.current?.submitForm()
                    }}><Translate message={`global.button.save`}/></Button>

                    <Button type="primary" className={`ant-btn-secondary`} onClick={() => {
                        onCancel && onCancel()
                    }}><Translate message={`global.button.view`}/></Button>
                </ButtonBar>
            </>
    )
})